import SalesLap from "../components/saleslap";

const SalesLapPage = () => {
    return (<>
        <SalesLap />
    </>
    )
}

export default SalesLapPage;